import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M2.63 3.406c0-.583.473-1.055 1.056-1.055h14.627c.583 0 1.055.472 1.055 1.055v14.556c0 .583-.472 1.055-1.055 1.055H3.686a1.056 1.056 0 0 1-1.055-1.055V3.406z",
      stroke: "currentColor",
      "stroke-width": "1.056"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.487 14.087h2.097c.91 0 1.365 0 1.624-.19a.971.971 0 0 0 .393-.697c.028-.32-.21-.706-.685-1.48l-.486-.793m-6.297-.92L7.081 11.72c-.474.774-.712 1.16-.684 1.48a.971.971 0 0 0 .393.697c.259.19.714.19 1.624.19h.876m4.096-4.861-1.054-1.717c-.44-.718-.661-1.077-.945-1.2a.98.98 0 0 0-.776 0c-.284.123-.504.482-.945 1.2l-.498.811m4.76-1.039-.536 1.993-2-.534m-5.275 1.749 2-.534.537 1.992m4.054 3.598-1.465-1.458 1.465-1.458",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }